import * as React from "react";
import { useCallback, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import Input from "components/bootstrap/Input";
import Select from "components/common/Select";
import usePluginEntities from "hooks/usePluginEntities";
import OptionSourceForm from "./OptionSourceForm";
const OptionParameterForm = ({
  idx,
  onChange,
  validationState,
  parameter: { source },
  onValidate
}) => {
  var _a, _b;
  const { t } = useTranslation("enterprise_common");
  const sourceTypes = usePluginEntities("views.parameters.option.sources");
  const options = useMemo(() => sourceTypes.map(({ type: type2, title }) => ({ key: title, value: type2 })), [sourceTypes]);
  const { type } = source != null ? source : {};
  const _onChange = useCallback(
    (newSourceType) => {
      const { factory } = sourceTypes.find(({ type: typeName }) => typeName === newSourceType);
      const newOptionSource = factory();
      return onChange("source", newOptionSource);
    },
    [onChange, sourceTypes]
  );
  const _onSourceChange = useCallback(
    (newOptionSource) => onChange("source", newOptionSource),
    [onChange]
  );
  useEffect(() => {
    const _validationState = type !== void 0 && type !== "" ? ["success"] : ["error", t("parameters.option_form.select_source")];
    onValidate(idx, { source: _validationState });
    return () => onValidate(idx, { source: ["success"] });
  }, [type, idx, onValidate, t]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: `source-${idx}`,
      name: "source",
      label: t("parameters.option_form.source"),
      bsStyle: (_a = validationState == null ? void 0 : validationState.source) == null ? void 0 : _a[0],
      help: (_b = validationState == null ? void 0 : validationState.source) == null ? void 0 : _b[1]
    },
    /* @__PURE__ */ React.createElement(
      Select,
      {
        placeholder: t("parameters.option_form.select_value_source"),
        displayKey: "key",
        inputId: "parameter-source-input",
        onChange: _onChange,
        value: type,
        options
      }
    )
  ), /* @__PURE__ */ React.createElement(
    OptionSourceForm,
    {
      idx,
      onChange: _onSourceChange,
      source,
      validationState,
      onValidate
    }
  ));
};
export default OptionParameterForm;
